import { FormSubmissionList } from "./FormSubmissionList";
import { FormSubmissionShow } from "./FormSubmissionShow";

export default {
  list: FormSubmissionList,
  show: FormSubmissionShow,
  recordRepresentation: (record: { id: string | number; form_name?: string }) =>
    record?.form_name
      ? `${record.form_name} #${record.id}`
      : `Submissão #${record?.id}`,
};
